module.exports = __webpack_public_path__ + "static/img/logo19.e7349891.png";